import { NavigateOptions, To, useNavigate } from 'react-router-dom'

export const useTabNavigate = (): ((to: To, options?: NavigateOptions) => void) => {
  const navigate = useNavigate()

  return (to: To, options?: NavigateOptions) => {
    navigate(`../${to}`, { ...options, relative: 'path' })
  }
}
